(() => {
  angular
    .module('gm.common.directives')
    .directive('btgBoxInput', btgBoxInputDirective);

  function btgBoxInputDirective() {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      require: 'ngModel',
      scope: {
        gmDisabled: '=?',
        options: '=?',
        tooltip: '@?',
        tooltipType: '@',
        label: '@',
        noLabel: '=?',
        placeholder: '@',
        type: '@?',
        metaLeft: '@?',
        metaRight: '@?',
        readonly: '@?',
        rightWarning: '@?',
      },
      templateUrl: 'modules/common/directives/forms/box-input/box-input.html',
      link(scope, _element, _attrs, ctrl) {
        scope.value = '';

        ctrl.$render = () => {
          scope.value = ctrl.$viewValue;
        };

        scope.$watch('value', (val) => {
          ctrl.$setViewValue(val);
        });

        scope.setActiveItem = (item) => {
          scope.value = item.value;
        };
      }
    };
  }
})();
